module.exports = __webpack_public_path__ + "img/Poland.0a8d52ca.svg";